<template>
  <page-template type="rightpanel" class="notifications-pages">
    <template v-slot:toolbar>
      <tool-bar @status-change="status = $event" type="statut-selector" title="Interventions" class="px-8"></tool-bar>
    </template>
    <template v-slot:central-panel-content>
      <div class="padding-x">
        <div class="pt-12">
          <p>Date et heure de la demande</p>
          <div class="d-flex justify-space-between">
            <h2 class="primary_">Nom et prénom locataire</h2>
            <h2 class="mr-12">Statut</h2>
          </div>
          <div class="d-flex intervention-category mb-4">
            <img src="/images/icons_interventions/plomberie.png" alt="" class="category-icon"/>
            <h4>Catégorie de l'intervention</h4>
          </div>
          <h2 class="mb-4 primary_">Intervenant</h2>
          <p class="mb-8">Descriptif</p>
          <div class="img-container">
            <div class="img-item">
              <img src="/images/ex_intervention.png" alt="" />
            </div>
          </div>
          <div class="d-flex justify-center mt-12">
            <button-popup type="devis" buttontext="Voir le devis"></button-popup>
            <v-btn class="mt-4 mx-4 primary-button outlined">Archiver</v-btn>
          </div>
          <div class="d-flex justify-center mt-12">
            <v-btn to="/annuaire" class="mt-4 mx-4 primary-button">Choisir un autre intervenant</v-btn>
            <v-btn class="mt-4 mx-4 primary-button outlined">Archiver</v-btn>
          </div>
          <div class="d-flex justify-center mt-12">
            <button-popup type="evaluation" buttontext="Voir l'évaluation"></button-popup>
            <v-btn class="mt-4 mx-4 primary-button outlined">Archiver</v-btn>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:right-panel-content>
      <h2 class="text-uppercase text-center">Interventions</h2>
      <panel-right-notification type="interventions" class="active"></panel-right-notification>
      <panel-right-notification type="interventions"></panel-right-notification>
      <panel-right-notification type="interventions"></panel-right-notification>
      <panel-right-notification type="interventions"></panel-right-notification>
      <panel-right-notification type="interventions"></panel-right-notification>
      <panel-right-notification type="interventions"></panel-right-notification>
    </template>
  </page-template>
</template>

<style lang="scss">

</style>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import panelRightNotification from '@/components/PanelRightNotification.vue'
  import buttonPopup from '@/components/ButtonPopup.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'Interventions',
    components: { pageTemplate, toolBar, panelRightNotification, buttonPopup },
    async created () {
      try {
        // ALL INTERVENTIONS
        const interventionsRes = await axios.get(`${apiURL}/intervention/all/1`)
        this.interventions = interventionsRes.data
        // INTERVENTION DETAIL
        const interventionDetailRes = await axios.get(`${apiURL}/intervention/:id`)
        this.interventionDetail = interventionDetailRes.data
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      }
    }
  }
</script>